















































































































import { Prop, Component, Vue, Watch } from 'vue-property-decorator'

type CloneListEntry = {
  selected: boolean
  item: Record<string, unknown>
}

/**
 * f2-304b1
 * グループ メンバー招待他グループから選択（ポップアップ等）
 */
@Component
export default class ModalMultiSelect extends Vue {
  @Prop({ default: 'multi-select' }) private id!: string
  @Prop() private title!: string
  @Prop() private mess!: string
  @Prop() private listItem!: any[] //requre `id` field
  @Prop() private listSelected?: any[] //requre `id` field
  @Prop() private displayNameKey!: string
  @Prop() private disableLoadMore!: boolean
  @Prop({ default: 12 }) private row!: number
  @Prop() private noFilterSelected!: boolean
  @Prop({ default: false }) loading!: boolean
  @Prop({ default: false }) revertUnsubmittedSelection!: boolean
  private cloneList: CloneListEntry[] = []
  searchKeyword = ''
  private defaultOrderIds: (string | number)[] = []
  private disableUp: boolean = false
  private disableDown: boolean = false
  private submitted = false
  private initialSelectionById = new Map<string | number, boolean>()

  get filteredSearchEntries(): CloneListEntry[] {
    const keyword = this.searchKeyword.trim().toLowerCase()
    if (!keyword) {
      return []
    }
    return this.cloneList
      .filter(entry =>
        this.getItemDisplayName(entry).toLowerCase().includes(keyword)
      )
      .sort((a, b) => this.getDefaultOrderIndex(a) - this.getDefaultOrderIndex(b))
  }

  get showEmptyMessage(): boolean {
    return !this.cloneList.length
  }

  getItemDisplayName(entry: CloneListEntry): string {
    const item = entry.item as Record<string, unknown>
    const value = item[this.displayNameKey] ?? item.name
    return String(value ?? '')
  }

  getItemKey(entry: CloneListEntry, index: number): string | number {
    const id = this.getItemId(entry)
    return id == null ? index : String(id)
  }

  getItemId(entry: CloneListEntry): string | number | undefined {
    const id = (entry.item as Record<string, unknown>).id
    return id == null ? undefined : (id as string | number)
  }

  getListItemClass(entry: CloneListEntry): Record<string, boolean> {
    return {
      'bg-secondary-less transition': entry.selected
    }
  }

  getDefaultOrderIndex(entry: CloneListEntry): number {
    const id = this.getItemId(entry)
    if (id == null) return 999999
    const index = this.defaultOrderIds.indexOf(id)
    return index >= 0 ? index : 999999
  }

  scrollListToEntry(entry: CloneListEntry) {
    this.$nextTick(() => {
      const area = this.$refs.displayNameArea as HTMLElement | undefined
      if (!area) return

      const index = this.cloneList.indexOf(entry)
      if (index < 0) return

      area.scrollTo({ top: index * 32, behavior: 'auto' })
      this.disableDirectBtn()
    })
  }

  mounted() {
    this.updateList()
  }

  @Watch('loading')
  onLoadingChange(isLoading: boolean) {
    if (!isLoading) {
      if (this.revertUnsubmittedSelection && !this.submitted) {
        this.saveInitialSelectionSnapshot()
      }
      this.cloneFromListItem()
    }
  }

  @Watch('listItem')
  @Watch('listSelected')
  @Watch('$route.query.multi_select')
  updateList() {
    this.cloneFromListItem()
    this.$nextTick(() => {
      this.disableDirectBtn()
      ;(this.$refs.displayNameArea as any)?.addEventListener(
        'scroll',
        () => {
          this.disableDirectBtn()
        }
      )
    })
  }

  handleShow() {
    this.searchKeyword = ''
    this.submitted = false
    if (this.revertUnsubmittedSelection) {
      this.saveInitialSelectionSnapshot()
    }
    this.cloneFromListItem()
  }

  saveInitialSelectionSnapshot() {
    this.initialSelectionById = new Map()
    this.listItem.forEach(item => {
      if (item.id != null) {
        this.initialSelectionById.set(item.id, !!item.selected)
      }
    })
  }

  restoreInitialSelection() {
    this.listItem.forEach(item => {
      if (item.id != null && this.initialSelectionById.has(item.id)) {
        item.selected = this.initialSelectionById.get(item.id)
      }
    })
    this.cloneFromListItem()
  }

  handleHidden() {
    if (this.revertUnsubmittedSelection && !this.submitted) {
      this.restoreInitialSelection()
      this.$router.replace({ query: {} }).catch(() => {})
    }
    this.submitted = false
  }

  cloneFromListItem() {
    const listSelectedIds = this.listSelected?.map(item => item.id)
    this.cloneList = this.listItem
      .filter(item => !listSelectedIds?.includes(item.id))
      .map(item => {
        return {
          selected: item.selected,
          item: item
        }
      })
    this.defaultOrderIds = this.cloneList
      .map(entry => this.getItemId(entry))
      .filter((id): id is string | number => id != null)
  }

  handleSelectItem(index: number) {
    const entry = this.cloneList[index]
    if (!entry) return

    this.setEntrySelected(entry, !entry.selected)
    this.$nextTick(() => this.disableDirectBtn())
  }

  setEntrySelected(entry: CloneListEntry, selected: boolean) {
    entry.selected = selected
    const item = entry.item as Record<string, unknown>
    if ('selected' in item) {
      item.selected = selected
    }
  }

  disableDirectBtn() {
    this.disableUp = (this.$refs.displayNameArea as any)
      ? (this.$refs.displayNameArea as any).scrollTop <= 0
      : true
    if (!this.disableLoadMore) {
      this.disableDown = false
      return
    }
    const listLength = this.cloneList.length
    this.disableDown = (this.$refs.displayNameArea as any)
      ? (this.$refs.displayNameArea as any).scrollTop >=
        32 * (listLength - this.row)
      : true
  }

  handleGoTop() {
    if (!this.disableUp) {
      ;(this.$refs.displayNameArea as any).scrollTop = 0
    }
  }

  handleGoUp() {
    if (!this.disableUp) {
      ;(this.$refs.displayNameArea as any).scrollTop =
        32 *
        (Math.floor((this.$refs.displayNameArea as any).scrollTop / 32) - 1)
    }
  }

  handleGoDown() {
    this.loadMore()
    if (!this.disableDown) {
      ;(this.$refs.displayNameArea as any).scrollTop =
        32 *
        (Math.floor((this.$refs.displayNameArea as any).scrollTop / 32) + 1)
    }
  }

  handleGoBottom() {
    this.loadMore()
    if (!this.disableDown) {
      ;(this.$refs.displayNameArea as any).scrollTop = (this.$refs
        .displayNameArea as any).scrollHeight
    }
  }

  loadMore() {
    if (!this.disableLoadMore) {
      this.$emit('loadMore')
    }
  }

  hideModal() {
    if (this.revertUnsubmittedSelection && !this.submitted) {
      this.restoreInitialSelection()
    } else {
      this.cloneFromListItem()
    }
    this.$bvModal.hide(this.id)
    this.searchKeyword = ''
    this.$router.replace({ query: {} }).catch(() => {})
  }

  onSubmit() {
    const selectedItems = this.cloneList
      .filter(item => item.selected)
      .map(item => item.item)
    if (!this.noFilterSelected) {
      this.cloneList = this.cloneList.filter(item => !item.selected)
    }
    this.submitted = true
    this.$emit('submit', selectedItems)
    this.$bvModal.hide(this.id)
    this.$router.replace({ query: {} }).catch(() => {})
  }
}
